import { useState } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { formatCurrency } from '@/lib/utils'
import { Receipt, ChevronDown, ChevronUp } from 'lucide-react'
// import { SubscriptionTransaction } from '@/types/billing'
import { cn } from '@/lib/utils'

// interface TransactionListProps {
//   transactions: SubscriptionTransaction[]
// }

export function TransactionList({ transactions }: any) {
  const [expandedSubscription, setExpandedSubscription] = useState<string | null>(null)

  const formatDate = (date: string) => {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  }

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'succeeded':
        return 'text-green-600 bg-green-50'
      case 'pending':
        return 'text-yellow-600 bg-yellow-50'
      case 'failed':
        return 'text-red-600 bg-red-50'
      default:
        return 'text-gray-600 bg-gray-50'
    }
  }

  const getSubscriptionBackground = (status: string) => {
    return status.toLowerCase() === 'active' ? 'bg-accent hover:bg-accent/80' : ''
  }

  return (
    <Card className='rounded-xl'>
      <CardHeader className='p-6'>
        <CardTitle className='text-xl font-medium'>Transaction History</CardTitle>
        <CardDescription className='font-normal'>View all your subscription payments and invoices</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4 p-6 pt-0">
        {transactions?.data?.length > 0 && transactions?.data.map((subscription: any, index: number) => (
          <div 
            key={index} 
            className={cn(
              "border rounded-lg",
              getSubscriptionBackground(subscription.status)
            )}
          >
            <div 
              className="flex items-center justify-between p-4 cursor-pointer hover:bg-muted/50"
              onClick={() => setExpandedSubscription(
                expandedSubscription === subscription.planType ? null : subscription.planType
              )}
            >
              <div className="space-y-1">
                <div className="font-medium">{subscription.planType}</div>
                <div className="text-sm text-muted-foreground">
                  {formatDate(subscription.period.start)} - {formatDate(subscription.period.end)}
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className={cn(
                  "text-xs px-2.5 py-0.5 rounded-full font-medium",
                  getStatusColor(subscription.status)
                )}>
                  {subscription.status}
                </span>
                {expandedSubscription === subscription.planType ? 
                  <ChevronUp className="h-4 w-4" /> : 
                  <ChevronDown className="h-4 w-4" />
                }
              </div>
            </div>

            {expandedSubscription === subscription.planType && (
              <div className="border-t divide-y">
                {subscription.transactions.map((transaction: any, transIndex: number) => (
                  <div key={transIndex} className="p-4 flex items-center justify-between hover:bg-muted/50">
                    <div className="flex items-center gap-4">
                      <Receipt className="h-4 w-4 text-muted-foreground" />
                      <div>
                        <div className="font-medium">
                          {formatCurrency(Math.abs(transaction.paymentAmount), transaction.currency)}
                          {transaction.paymentAmount < 0 && ' (Refund)'}
                        </div>
                        <div className="text-sm text-muted-foreground">
                          {formatDate(transaction.createdAt)}
                        </div>
                      </div>
                    </div>
                    {/* <div className="flex items-center gap-2">
                      {transaction.receiptUrl && (
                        <Button variant="ghost" size="sm" asChild>
                          <a href={transaction.receiptUrl} target="_blank" rel="noopener noreferrer">
                            Receipt
                            <ExternalLink className="ml-2 h-3 w-3" />
                          </a>
                        </Button>
                      )}
                      {transaction.invoiceUrl && (
                        <Button variant="ghost" size="sm" asChild>
                          <a href={transaction.invoiceUrl} target="_blank" rel="noopener noreferrer">
                            Invoice
                            <ExternalLink className="ml-2 h-3 w-3" />
                          </a>
                        </Button>
                      )}
                    </div> */}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </CardContent>
    </Card>
  )
}